export default function parseFilename(filename: string): {
  name: string;
  extension: string;
} {
  const lastDotIndex = filename.lastIndexOf('.');
  return {
    name: lastDotIndex > 0 ? filename.slice(0, lastDotIndex) : filename,
    extension: lastDotIndex > 0 ? filename.slice(lastDotIndex + 1) : '',
  };
}
